<ng-template [ngIf]="displayMode === 'default'">
  <div *ngIf="item && show"
       class="content-card lesson-card"
       [class.show]="show"
       [class.inline]="inline"
       [class.active]="active"
       itemscope itemtype="https://schema.org/Article">

    <app-content-meta *ngIf="!isPrivate" [meta]="meta"></app-content-meta>

    <div *ngIf="canClose && !isPrivate" class="close-btn" (click)="closeCard()">
      <app-icon class="close-btn-icon" icon="close"></app-icon>
    </div>

    <div class="meta" [class.not-scrolled]="deviceService.isMobile()" *ngIf="!isPrivate">
      <ng-container *ngTemplateOutlet="imgWrap"></ng-container>

      <div class="details">
        <ng-container *ngTemplateOutlet="metaLinks"></ng-container>
        <app-author-info [user]="author"></app-author-info>
      </div>

      <div class="right-side">
        <ng-container *ngTemplateOutlet="toolBar"></ng-container>
        <div class="passed">
          <span class="grade normal">{{ passGrade }}</span>
        </div>
        <div class="buttons" [attr.data-test]="'start-lesson'">
          <ng-template [ngIf]="(me$ | async) && isAccessGranted">
            <on-ui-button [state]="state.playButton"
                          class="primary"
                          [label]="'library.card-action-start-lesson'"
                          (onclick)="playLesson()">
            </on-ui-button>
          </ng-template>
        </div>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>

    <div *ngIf="!isPrivate" class="buttons-mini">
      <ng-template [ngIf]="(me$ | async) && isAccessGranted">
        <on-ui-button [state]="state.playButton"
                      class="primary"
                      [label]="'library.card-action-start-lesson'"
                      (onclick)="playLesson()">
        </on-ui-button>
      </ng-template>
    </div>

    <ng-template [ngIf]="item && !isPrivate">
      <app-share-and-stats [content_id]="item?.id"
                           [stats]="item?.stats"
                           [visit_info]="item?.visit_info"
                           (shared)="onCopied($event)"
                           (changed)="onShareAndStatsChange($event)">
      </app-share-and-stats>

      <app-content-comments [content]="item"
                            (commented)="setIsCommented()"
                            (changed)="onCommentsChange($event)">
      </app-content-comments>
    </ng-template>

    <ng-template [ngIf]="isPrivate">
      <div class="spinner-wrap" *ngIf="!lessonInCollections">
        <spinner1 class="spinner"></spinner1>
      </div>
      <app-private-content-informer *ngIf="lessonInCollections" [collections]="lessonInCollections"></app-private-content-informer>
    </ng-template>
  </div>
</ng-template>

<ng-template [ngIf]="displayMode === 'content_page'">
  <div *ngIf="item && show"
       class="content-card-content-page"
       itemscope itemtype="https://schema.org/Article">

    <app-content-meta [meta]="meta"></app-content-meta>

    <ng-template [ngIf]="!isPrivate">
      <div class="meta" [class.not-scrolled]="deviceService.isMobile()">
        <ng-container *ngTemplateOutlet="imgWrap"></ng-container>
        <ng-container *ngTemplateOutlet="metaLinks"></ng-container>
      </div>

      <app-author-info [user]="author"></app-author-info>

      <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>

      <div class="start-lesson-action">
      <ng-template [ngIf]="(me$ | async) && isAccessGranted">
        <on-ui-button [state]="state.playButton"
                      class="primary"
                      [label]="'library.card-action-start-lesson'"
                      (onclick)="playLesson()">
        </on-ui-button>
      </ng-template>
    </div>

      <app-share-and-stats [content_id]="item?.id"
                           [stats]="item?.stats"
                           [visit_info]="item?.visit_info"
                           (shared)="onCopied($event)"
                           (changed)="onShareAndStatsChange($event)">
    </app-share-and-stats>
    </ng-template>

    <ng-template [ngIf]="isPrivate">
      <div class="spinner-wrap" *ngIf="!lessonInCollections">
        <spinner1 class="spinner"></spinner1>
      </div>
      <app-private-content-informer *ngIf="lessonInCollections" [collections]="lessonInCollections"></app-private-content-informer>
    </ng-template>

    <app-content-comments [content]="item"
                          (commented)="setIsCommented()"
                          (changed)="onCommentsChange($event)">
    </app-content-comments>
  </div>
</ng-template>

<ng-template #metaLinks>
  <div class="meta-links">
    <ng-template [ngIf]="!deviceService.isDesktop()">
      <ng-container *ngTemplateOutlet="toolBar"></ng-container>
    </ng-template>
    <h1 class="title"><a [routerLink]="isMeVersion() ? null : contentRoute(item)">{{ title }}</a></h1>
    <h2 class="subject-wrap">
      <a *ngIf="subjectRoute" [routerLink]="isMeVersion() ? null : subjectRoute" class="subject">{{ subject }}</a>
      <span *ngIf="!subjectRoute" class="subject">{{ subject }}</span>

      <ng-template [ngIf]="item?.subject?.category_id === subjectCategoryEnum.native_language">
        <span class="subject-category">{{ 'content-mini-card.native' | customLocale }}</span>
      </ng-template>
    </h2>

    <h3 class="subtitle" *ngIf="item.sub_title"><a [routerLink]="isMeVersion() ? null : contentRoute(item)">{{ sub_title }}</a></h3>
    <h4 class="type-and-level">
      <a *ngIf="contentTypeRoute" [routerLink]="isMeVersion() ? null : contentTypeRoute"
         [attr.title]="(contentTypeTitle | customLocale) + ', ' + (level)">
        {{ contentTypeTitle | customLocale }}, {{ level }}
      </a>
      <span *ngIf="!contentTypeRoute">{{ contentTypeTitle | customLocale }}, {{ level }}</span>
      <br/>
      <span>{{ 'constructor2.form-language-label' | customLocale }}: {{ teachingLanguage }}</span>
    </h4>
  </div>
</ng-template>

<ng-template #imgWrap>
  <div class="img-wrap">
    <on-ui-cover [cover]="cover" [attr.data-test] = "'coverImg'"></on-ui-cover>
  </div>
</ng-template>

<ng-template #descriptionTemplate>
  <p class="description" *ngIf="!isPrivate && description">
    <span [innerHTML]="description | striptags | nl2br" itemprop="description"></span>
    <ng-template [ngIf]="isBrowser && isCutable">
      <span class="description description--more" (click)="toggleCut()">
        {{ (state.cut ? 'library.read-more' : 'library.read-hide') | customLocale }}
      </span>
    </ng-template>
  </p>
</ng-template>

<ng-template #toolBar>
  <div class="toolbar" *ngIf="isBrowser">
    <div class="copied-informer" [class.active]="state.copied"><span>{{'invite-card.link-copied' | customLocale}}</span></div>
    <app-bookmark [item]="item" type="content" (favoriteChanged)="onFavoriteChanged()"></app-bookmark>
    <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #menuTemplate>
  <on-ui-card-menu [item]="item">
    <a class="menu-item"
       *ngIf="isAuthor"
       [routerLink]="['/constructor/edit', item.id]">
      {{ 'library.menu-edit' | customLocale }}</a>
    <a class="menu-item warn"
       *ngIf="!isAuthor && isModerator"
       [routerLink]="['/constructor/edit', item.id]">[⚠️] Edit</a>
    <a class="menu-item warn"
       *ngIf="item.purl" [href]="item.purl">[⚠️] Panel</a>
    <div class="menu-item"
         *ngIf="state.subscribed"
         (click)="unsubscribe()">{{ 'library.menu-unsubscribe' | customLocale }}</div>
    <div *ngIf="isAvailableStatistics" class="menu-item" #shareLinkRef>
      <button type="button"
              [ngxClipboard]
              [cbContent]="contentUrl"
              (cbOnSuccess)="onCopied($event)"
              [container]="shareLinkRef">{{ 'library.menu-share' | customLocale }}<!-- Поделиться -->
      </button>
    </div>
    <div class="menu-item"
         *ngIf="!isAuthor && isAccessGranted"
         (click)="openComplainForm()">{{ 'library.menu-complain' | customLocale }}<!-- Пожаловаться --></div>
  </on-ui-card-menu>
</ng-template>

<app-alert type="info" *ngIf="state.replayAlert">
  <ng-container alert-title>{{ 'game.replay-game-confirmation.title' | customLocale }}</ng-container>
  <ng-container alert-body>
    <div [innerHTML]="'game.replay-game-confirmation.body' | customLocale"></div>
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button [attr.data-test]="'show-last-game'"
                  class="primary outline"
                  label="game.replay-game-confirmation.action-show"
                  (onclick)="showLastGame()">
    </on-ui-button>
    <on-ui-button [attr.data-test]="'play-lesson-again'"
                  class="primary"
                  label="game.replay-game-confirmation.action-replay"
                  (onclick)="playLessonAgain()">
    </on-ui-button>
  </ng-container>
</app-alert>

<app-lesson-game *ngIf="state.play"
                 [gameMode]="state.gameMode"
                 [lessonId]="item?.id"
                 [replayGameId]="replayGameId ? replayGameId : null"
                 [author]="author"
                 [withoutHeader]="playAutomatically"
                 (submitted)="onLessonReviewSubmitted()"
                 (loaded)="gameLoaded()"
                 (closed)="stopPlay()">
</app-lesson-game>

<app-modal *ngIf="state.complainFormOpened && deviceService.isDesktop()"
           (closed)="closeComplainForm()"
           canClose="true"
           middle="true">
  <app-modal-body class="vmodal">
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()">
    </app-complaint-form>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="state.complainFormOpened && !deviceService.isDesktop()"
                  [titleVisible]="false"
                  (closed)="closeComplainForm()">
  <app-mobile-modal-body>
    <app-complaint-form [type]="'content'"
                        (cancel)="closeComplainForm()">
    </app-complaint-form>
  </app-mobile-modal-body>
</app-mobile-modal>
